import React, { useEffect } from "react";
import AppBar from "./AppBar";
import { Container, Row, Col } from "react-bootstrap";
import Footer from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaWhatsapp, FaShieldAlt, FaGift } from "react-icons/fa";

const Chitsfunds = () => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      delay: 300,
      duration: 1500,
      easing: "ease",
    });
  }, []);

  return (
    <>
      <AppBar />

      <div className="padding bg-white">
        <Container>
          <Row className="align-items-center">
            <Col lg="12" className="text-center pb-4">
              <span className="badge bg-warning text-dark bold px-3 py-1 rounded-pill mb-2 text-uppercase">
                ✨ Festival Savings Scheme ✨
              </span>
              <h1 className="bold text-center lg-font text-dark mt-2 mb-2">
                Diwali Cracker Chit Fund Scheme
              </h1>
              <p className="text-muted bold fs-5 mx-auto" style={{ maxWidth: "700px" }}>
                Plan your Diwali celebrations in advance with small monthly installments and get <strong className="text-danger">bumper cracker gift boxes</strong> with extra festival bonuses!
              </p>
            </Col>

            <Col lg="7" className="py-3" data-aos="fade-right">
              <div className="p-2 bg-light rounded-4 shadow-sm border text-center">
                <img
                  src={require("../../assets/images/banner/chitfund.jpg")}
                  className="img-fluid rounded-3"
                  alt="Diwali Chit Fund Scheme"
                />
              </div>
            </Col>

            <Col lg="5" className="py-3" data-aos="fade-left">
              <div className="p-4 bg-light rounded-4 border shadow-sm">
                <h4 className="bold text-dark mb-3">
                  Scheme Highlights & Benefits
                </h4>

                <ul className="list-unstyled mb-4">
                  <li className="d-flex align-items-start gap-2 mb-3">
                    <div className="bg-success text-white rounded-circle p-1 mt-1">
                      <FaShieldAlt size={14} />
                    </div>
                    <div>
                      <strong className="bold text-dark d-block">100% Guaranteed Delivery</strong>
                      <span className="regular text-muted small">Assured doorstep cracker delivery before Diwali festival.</span>
                    </div>
                  </li>
                  <li className="d-flex align-items-start gap-2 mb-3">
                    <div className="bg-danger text-white rounded-circle p-1 mt-1">
                      <FaGift size={14} />
                    </div>
                    <div>
                      <strong className="bold text-dark d-block">Special Bumper Bonus</strong>
                      <span className="regular text-muted small">Extra free fancy sky shots and sparkles with every completed scheme.</span>
                    </div>
                  </li>
                  <li className="d-flex align-items-start gap-2">
                    <div className="bg-primary text-white rounded-circle p-1 mt-1">
                      <FaShieldAlt size={14} />
                    </div>
                    <div>
                      <strong className="bold text-dark d-block">Easy Monthly Payments</strong>
                      <span className="regular text-muted small">Flexible payment via Google Pay, PhonePe, or Bank Transfer.</span>
                    </div>
                  </li>
                </ul>

                <div className="text-center pt-2">
                  <a
                    href="https://wa.me/919843058048?text=Hello%20GMR%20Crackers,%20I%20am%20interested%20in%20joining%20the%20Diwali%20Chit%20Fund%20Scheme"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success btn-lg w-100 rounded-pill bold d-flex align-items-center justify-content-center gap-2 shadow"
                  >
                    <FaWhatsapp size={22} /> Join Scheme on WhatsApp
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Chitsfunds;

